import * as CryptoJS from "crypto-js";

/**
 * Deterministically derive a Cognito username from an email address.
 *
 * The same email always produces the same username, so users never need to
 * pick or remember a separate username — they only ever provide their email.
 *
 * The result is the SHA-256 hex digest of the normalized (trimmed, lowercased)
 * email: 64 chars of [0-9a-f], which satisfies Cognito username constraints and
 * the app's [a-z0-9]+ username validators.
 *
 * Implemented with crypto-js (not the Web Crypto API) so it works outside of a
 * secure context too — window.crypto.subtle is undefined over plain HTTP (e.g.
 * dev servers / IP origins), which otherwise throws "cannot read properties of
 * undefined (reading 'digest')". This hash matches the server's CryptoJS.SHA256.
 */
export async function emailToUsername(email: string | null | undefined): Promise<string> {
  const normalized = (email || "").trim().toLowerCase();
  return CryptoJS.SHA256(normalized).toString(CryptoJS.enc.Hex);
}
